import React from "react";
import "./cards.css";
import ARROW_ICON_SVG from "../../../assets/icons/arrow-right.svg";
import ModalImage from "react-modal-image";

const ContactUsCard = ({ text, cta, callback }) => {
  return (
    <div className="cu-container" onClick={callback}>
      <div className="text-container">{text}</div>
      <div className="cta-container">
        {cta}
        <img src={ARROW_ICON_SVG} className="cta-icon" alt="icon" />
      </div>
    </div>
  );
};

const ReferenceCard = ({ reference }) => {
  return (
    <div className="reference-container">
      <ModalImage
        small={reference.image}
        large={reference.image}
        alt={"Producto"}
        className="reference-principal-img"
      />
      {reference.measures_ref.map((measure, index) => (
        <div
          className={`reference-measure ${
            index === 0 ? "reference-measure-strong" : ""
          }`}
        >
          {measure}
        </div>
      ))}
    </div>
  );
};

const ResourceCard = ({ resource }) => {
  return (
    <div className="reference-container">
      <ModalImage
        small={resource.image}
        large={resource.image}
        alt={resource.name}
        className="resource-image"
      />
      <div className="resource-title">{resource.name}</div>
    </div>
  );
};

export { ContactUsCard, ReferenceCard, ResourceCard };
